import { MultiMetricOptionMixin } from '../../mixin';
import metricTranslatorMixin from '@/mixins/translator/metric';

import ChipList from '../../../components/ChipList';
import Chip from '../../../components/Chip';

import MetricIcon from '@svgIcons/dashboard/metric.svg';

import * as C from '../../../options/styles';

import { isValueExist, changeOrder } from '@util';
import { IFRAME_EVENT_MESSAGE } from '@consts';
import { FIELD_KEY, makeMetricFormat } from '../../utils';
import { FIELD_PANEL_KEY, MAX_GOAL_METRIC_COUNT } from '../../consts';

export default {
    name: 'MetricSetting',
    mixins: [MultiMetricOptionMixin, metricTranslatorMixin],
    props: {
        panelKey: {
            type: String,
            default: () => FIELD_PANEL_KEY.GOAL_METRICS(),
        },
        currentList: {
            type: Array,
            default() {
                return [];
            },
        },
        canEditCustomMetric: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            iframeListeners_: [
                {
                    eventType: IFRAME_EVENT_MESSAGE.UPDATE_METRIC_PANEL,
                    listener: (e) => {
                        const { data } = e;
                        if (!data || data.panelKey !== this.panelKey) return;
                        const { selectedFields } = data;

                        const existingByKey = R.indexBy(
                            R.prop(FIELD_KEY),
                            this.currentList
                        );
                        const updated = selectedFields.map((field) => {
                            return existingByKey[field] || { key: field };
                        });
                        this.$emit('update', updated);
                    },
                },
            ],
        };
    },
    computed: {
        title() {
            return this.$t('FIELD_PANEL.metric.second_panel_title');
        },
        mainGuide() {
            return this.$t('FIELD_PANEL.metric.second_panel_main_guide');
        },
        subGuide() {
            return this.$t('FIELD_PANEL.metric.second_panel_sub_guide');
        },
        limitCount() {
            return MAX_GOAL_METRIC_COUNT;
        },
    },
    methods: {
        reorderItems({ oldIndex, newIndex }) {
            const updated = changeOrder({
                oldIndex,
                newIndex,
                value: this.currentList,
            });
            this.$emit('update', updated);
        },
        removeItem(item) {
            const targetKey = item[FIELD_KEY];
            const updated = R.filter(
                R.complement(R.propEq(FIELD_KEY, targetKey))
            )(this.currentList);
            this.$emit('update', updated);
        },
        renderItem() {
            const { cursor, renderNoList, currentList, disabled } = this;

            return (
                <C.ItemWrapper>
                    {isValueExist(currentList) ? (
                        <ChipList
                            value={currentList}
                            disabled={disabled}
                            onReorder={this.reorderItems}
                        >
                            {currentList.map((item) => {
                                const title = this.getMetricName(makeMetricFormat(item[FIELD_KEY]));

                                return (
                                    <Chip
                                        key={`${item.key}`}
                                        title={title}
                                        dragCursor={cursor}
                                        sortable
                                        removable
                                        onRemove={() => {
                                            this.removeItem(item);
                                        }}
                                    />
                                );
                            })}
                        </ChipList>
                    ) : (
                        renderNoList(
                            this.$t('EDITABLE_DASHBOARD.list_empty_metric')
                        )
                    )}
                </C.ItemWrapper>
            );
        },
    },
    render() {
        return (
            <C.ComponentWrapper>
                {this.wrapOptions({
                    children: this.renderItem(),
                    title: this.$t('NEW_DASHBOARD.order_of_columns'),
                    icon: <MetricIcon class="metric-icon" />,
                    loading: this.fieldLabelsLoading,
                })}
            </C.ComponentWrapper>
        );
    },
};
